import { render, staticRenderFns } from "./notifications-informer-export-complete.vue?vue&type=template&id=68043b6a&"
import script from "./notifications-informer-export-complete.vue?vue&type=script&lang=js&"
export * from "./notifications-informer-export-complete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports